import React from "react"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import { useNotifications } from "./Notifications"
import { Notification } from "@xingternal/360-components"
import { Box } from "@xingternal/winery-ui/lib/Box"

const NotificationWrapper = styled(Box)`
  position: fixed;
  right: 0;
  top: 0;
  width: 400px;
  z-index: ${themeGet("zIndices.notificationLevel")};
  animation: show 0.5s ease;

  @keyframes show {
    from {
      right: -500px;
      opacity: 0;
    }
    to {
      right: 0;
      opacity: 1;
    }
  }
`

const NotificationsRoot = () => {
  const { messages } = useNotifications()

  if (messages.length) {
    const [firstMessage] = messages

    return (
      <NotificationWrapper mt={9} mr={4}>
        <Notification
          message={firstMessage.message}
          showCloseIcon={false}
          type={firstMessage.notificationType}
        />
      </NotificationWrapper>
    )
  }

  return null
}

export { NotificationsRoot }
